export default {
    components: {
      surveyReward: {
        title: '¡Recibiste una tarjeta de regalo de {rewardAmount}!',
        description:
          'Como agradecimiento por participar en la encuesta BeHeard de su organización, {companyName} le proporciona una tarjeta de regalo por el monto de {rewardAmount}. Haga clic en una de las siguientes marcas para seleccionar su tarjeta de regalo. ¡Gracias de nuevo por hacer que se escuche tu voz!',
        youSelected: 'Usted seleccionó: {giftCardName}',
        chooseAnother: 'Elige otro',
        confirmThisGiftCard: 'Confirma esta tarjeta de regalo',
      },
      demographicsFilters: {
        noResults: 'No results matched your selection.',
        lessThanFiveRespondents:
          'To protect employee privacy, we do not display results with less than 5 respondents.',
        modifySelections: 'Please modify your selections and try again.',
        snackbar: { success: { resetFilters: 'Your filters have been reset.' } },
        buttons: { resetFilters: 'Reset Filters', applyFilters: 'Apply Filters' },
      },
      survey: {
        engagementReportComparisonComponent: {
          info: 'Find specific information for each metric when you hover over this icon.',
        },
      },
      mediaDisplay: {
        snackbar: { warning: 'Unable to locate media. Please try again.' },
      },
      receivedReward: {
        snackbar: {
          success: {
            acceptedReward: 'You accepted this reward!',
            bankedReward: 'You banked this reward!',
            redeemedReward: 'You redeemed this reward!',
          },
        },
        getStatusLabels: {
          received: 'received a',
          accepted: 'accepted this',
          banked: 'banked this',
          redeemed: 'redeemed this',
        },
        getStatusLabelsTooltip: {
          received:
            'You just received this reward! You can accept it or bank it. Banked rewards will add up to your wallet balance',
          accepted: 'You accepted this reward. Make sure you redeemed it',
          banked:
            'You banked this reward. This reward amount was already added to your wallet balance',
          redeemed:
            'You redeemed this reward! You should have received an e-mail with details about it',
        },
        shareWhyYouBankedIt: 'Share with us why you banked it',
        rewardWasAutomaticallyBanked: 'This reward was automatically banked',
        rewardStatus: 'You {status} Reward!',
        actionButtonLabels: { bank: 'Bank', accept: 'Accept' },
        bankedReason: 'Banked Reason: {reason}',
        youRatedThisReward: 'You rated this reward:',
        rateThisReward: 'Rate this reward:',
        notAcceptedReasonDialogTitle: 'Why I banked {rewardName}',
        bankedReasonLabel: 'Banked Reason',
        bankedReasonPlaceholder: 'I decided to bank this reward because...',
      },
      purchaseRetailerRewardDialog: {
        title: 'Seleccionar Recompensa Minorista',
        retailerRewardDetails: 'Retailer Reward Details',
        amountToSpend: 'Cantidad que desea gastar',
        maxAmountMessage: 'La cantidad no puede ser mayor que {amount}',
        searchRewards: 'Buscar Recompensas',
        noRewards:
          'No hay Recompensas. Asegúrese de establecer una cantidad en el campo de arriba.',
        purchaseFromBrand:
          '¿Quieres comprar una tarjeta de regalo de {amount} de {brand}?',
        confirmPurchase: 'Confirmar Compra',
        snackbar: {
          giftCardPurchased: '¡Su tarjeta de regalo se compró con éxito!',
        },
      },
      reportInappropriateContent: {
        snackbar: {
          success: {
            reportSent:
              'Your report was successfully sent to our moderation team.',
          },
        },
        header: 'Report this',
        question: {
          firstLine: 'What did you find in this',
          secondLine: 'that was inappropriate?',
        },
        contentLabels: {
          text: 'Has Inappropriate Text',
          image: 'Has Inappropriate Image',
          video: 'Has Inappropriate Video',
        },
        report: 'Report',
      },
      adminCompaniesSelect: { textFieldLabel: 'Organization as Admin' },
      adminMode: 'Admin mode',
      dropzone: "Drag 'n' drop some files here, or click to select files",
      errorBoundary: {
        somethingHappened: 'Well, that was unexpected.',
        unexpectedError:
          "We know this isn't what you expected but you just found a bug and are making our system better. Our team has been notified and we should have everything we need to fix this issue quickly. However, if you would like to reach out to our Support team, simply email us at {email}. Otherwise you can click the button below and we will take you to a place that is bug free... hopefully.",
        reloadThisPage: 'Take me to another page',
      },
      loadMoreButton: { loadMore: 'Load more', remaining: 'remaining...' },
      passwordRules: {
        lowercaseLetter: 'a lowercase letter',
        capitalLetter: 'a capital letter',
        number: 'a number',
        atLeastEightCharacters: 'at least 8 characters',
        specialCharacter: 'a special character (+, #, !, ? or @)',
        passwordMustContain: 'The password must contain:',
      },
      profileAutocompleteQuestions: {
        placeholder: 'Please submit one answer at a time...',
        save: 'Save',
        dialogTitle: 'Remove Answer',
        dialogContent: 'Are you sure you want to remove',
        removeAnswer: 'Remove Answer',
        legendLabels: {
          managers: "Manager's answers",
          employees: "Employee's answers",
        },
        listLabel: 'questions',
      },
      recognitionsByEvent: { noData: 'There is no data to display yet.' },
      termsAndConditions: {
        dialogTitle: 'Sparck Terms and Conditions',
        okButton: 'Ok, got it',
      },
      upgradeCostEstimate: {
        contactUs: 'Contact us for a custom quote',
        estimateYourCost: 'Estimate Your Cost to Upgrade',
        numberOfEmployees:
          'How many employees do you have? (Slide the bar until you reach your headcount).',
        employees: 'employees',
        estimatedReportCost: 'Estimated Report Cost',
      },
      reportComparison: {
        features: 'Features',
        freeReport: 'Free\nReport',
        premiumReport: 'Premium\nReport',
        companyEngagementScore: {
          title: 'Organization Engagement Score',
          tooltip:
            'The extent to which employees feel passionate about their jobs, are committed to our organization, put discretionary effort into their work and are willing to refer.  Results can easily be filtered by workplace demographics.',
        },
        participationRate: { title: 'Participation Rate' },
        customQuestions: { title: 'Custom Questions' },
        shortTermTurnover: {
          title: 'Short-Term Turnover',
          tooltip:
            'Based on your results, you can get a pulse on potential turnover in the next 12 months. Results can easily be filtered by workplace demographics.',
        },
        longTermTurnover: {
          title: 'Long-Term Turnover',
          tooltip:
            'Based on your results, you can get a pulse on how committed your employees are to building their career with you long term. Results can easily be filtered by workplace demographics.',
        },
        filters: {
          title: 'Filters',
          tooltip:
            'Use demographic filters to analyze data including Engagement Drivers, Turnover, Action Areas, Strengths, and Most Important Items.',
        },
        collaborationEffectivenessScore: {
          title: 'Collaboration Effectiveness Score',
          tooltip:
            'The extent to which the organization promotes a team-based work style (i.e. departments or groups work well together).',
        },
        jobFitEffectivenessScore: {
          title: 'Job Fit Effectiveness Score',
          tooltip:
            'The extent to which employees feel they are in the right jobs and have the necessary skills, knowledge and abilities to adequately perform in their roles.',
        },
        employeeAppreciationScore: {
          title: 'Employee Appreciation Score',
          tooltip:
            'The extent to which employees feel valued by the organization. Results can be easily filtered by workplace demographics.',
        },
        organizationalAlignmentScore: {
          title: 'Organizational Alignment Score',
          tooltip:
            'The extent to which employees believe in and put effort toward the organization’s mission, values and goals.',
        },
        growthEffectivenessScore: {
          title: 'Growth Effectiveness Score',
          tooltip:
            'The extent to which employees feel supported to advance their career or develop personal skill sets within the organization.  Results can easily be filtered by workplace demographics.',
        },
        topFiveMostImportantAreas: {
          title: 'Top Five Most Important Areas',
          tooltip:
            'These are the engagement areas that ranked most important to your employees. Results can easily be filtered by workplace demographics.',
        },
        topFiveFocusAreasForGreatestRoi: {
          title: 'Top Five Focus Areas for Greatest ROI',
          tooltip:
            'These are the areas that you should focus on to get the greatest return on your investment to increase engagement. These are the engagement areas that are most important to your employees where they feel the organization is least effective. Results can easily be filtered by workplace demographics.',
        },
        topFiveCompanyStrengths: {
          title: 'Top Five Organization Strengths',
          tooltip:
            'These are the areas where you are strongest, great data to build your employer brand.  These are the engagement areas that were most important to your employees and where they also felt you were most effective. Results can easily be filtered by workplace demographics.',
        },
        actionableRecommendationsOrganizationAndManagers: {
          title: 'Actionable Recommendations (Organization and Managers)',
          tooltip:
            'Based on your top five focus areas to get the greatest engagement ROI, a team of I/O psychologists took proven strategies to personalize each organizational and management recommendation. Results can easily be filtered by workplace demographics.',
        },
      },
      employeesUploadComponent: {
        warningMessage:
          'Pudimos importar solo {importedEmployees} empleados. Por favor corrija los errores que ve a continuación y vuelva a intentarlo.',
        errorContainerMessage:
          'Para ver lo que se requiere o el formato correcto para cualquier campo, consulte nuestra plantilla en el enlace de arriba.',
        errorTable: {
          columns: {
            row: 'Hilera',
            missingValues: 'Valores Faltantes',
            invalidFormat: 'Formato Inválido',
          },
        },
        employeeUploadFields: {
          companyInternalId: 'ID de Empleado',
          cellNumber: 'Teléfono Celular',
          title: 'Título',
          hiredAt: 'Fecha de Contratación',
          gender: 'Género',
          ethnicity: 'Etnia',
          dateOfBirth: 'Fecha de Cumpleaños',
          job_type: 'FT/PT',
          businessUnit: 'Unidad de Negocio',
          region: 'Región',
          territory: 'Territorio',
          locationName: 'Localización',
          city: 'Ciudad',
          state: 'Estado/Provincia',
          country: 'País',
          postalCode: 'Código Postal',
          performanceLevel: 'Nivel de Desempeño',
          highValueTalent: 'Talento de Alto Valor',
          roles: 'Roles',
          superiors: 'Supervisores',
          preferredLanguage: 'Idioma',
        },
      },
      mediaPicker: {
        addMedia: 'Agregar Imagen/Video',
        addGif: 'Agregar GIF',
        addCard: 'Agregar Tarjeta',
        dragAndDrop:
          'Arrastra y suelta imágenes y videos o simplemente haz clic aquí.',
        pasteLink: 'o pegue un enlace de imagen/video:',
        pasteLinkPlaceholder: 'p.ej. imagen, youtube, vimeo, etc.',
        verify: 'Verificar',
        sparckCardsDialog: {
          title: 'Tarjetas Sparck',
          noCards: 'No hay tarjetas disponibles.',
        },
      },
      demographicsPicker: {
        add: 'Agregar',
        additional: 'Otro',
        demographic: 'Dato Demográfico',
      },
      popupSteps: {
        gotIt: 'Got it!',
        next: 'Next',
        dontShowAgain: "Don't show again",
        back: 'Back',
      },
      phoneNumberInputWithFormatPicker: {
        chooseCountry: 'Choose a country',
      },
      confirmationDialog: {
        delete: 'delete',
        defaultMessage: 'Are you sure you want to {action} {item}?',
        launchBeheardSurveyMessage:
          'You are about to launch your survey and send each employee an email to take the survey. Please make sure you have added all participant employees before launching your survey by clicking {link}. If you are ready to launch click the Launch Survey button below.',
        launchPulseSurveyMessage:
          'You are about to launch your survey and send each employee an email to take the survey. If you are ready to launch, click the Launch Pulse Survey button below.',
      },
    },
  }

